import React from "react";
import { Tooltip as AntTooltip } from "antd";
import Popover from "../Popover/Popover";

/**
 * Wrapper component for Ant Design Tooltip
 *
 * This wrapper allows us to easily replace Ant Design in the future without changing all imports.
 * It preserves all Ant Design Tooltip functionality including placement, trigger, and overlay options.
 *
 * @component
 * @example
 * import { Tooltip } from '../GeneralComponents/ui';
 *
 * <Tooltip title="Prompt Text">
 *   <span>Tooltip will show on mouse enter.</span>
 * </Tooltip>
 *
 * <Tooltip placement="topLeft" title="Prompt Text">
 *   <Button>TL</Button>
 * </Tooltip>
 *
 * @see https://ant.design/components/tooltip/ - Ant Design Tooltip documentation
 */
const Tooltip = (props) => {
  const {
    tooltip,
    tooltipPlacement,
    title,
    placement = "top",
    children,
    getPopupContainer,
    showArrow = false,
    maxWidth,
    ...rest
  } = props;

  // Support legacy props (tooltip/tooltipPlacement) by mapping to Ant Design's API.
  const mappedTitle = tooltip !== undefined ? tooltip : title;
  const mappedPlacement =
    tooltipPlacement !== undefined ? tooltipPlacement : placement;

  return (
    <AntTooltip
      {...rest}
      zIndex={rest.zIndex || 2000}
      title={mappedTitle}
      placement={mappedPlacement}
      getPopupContainer={getPopupContainer}
      overlayInnerStyle={{
        fontSize: 14,
        borderRadius: 16,
        maxWidth: maxWidth,
      }}
      showArrow={showArrow}
    >
      {children}
    </AntTooltip>
  );

  // return (
  //   <Popover
  //     {...rest}
  //     content={mappedTitle}
  //     placement={mappedPlacement}
  //     getPopupContainer={typeof getPopupContainer === "function" && (trigger => getPopupContainer(trigger))}
  //     trigger="hover"
  //     showArrow={showArrow}
  //     overlayInnerStyle={{
  //       fontSize: 14,
  //       borderRadius: 16,
  //       overflow: 'hidden',
  //       maxWidth: maxWidth,
  //     }}
  //   >
  //     {children}
  //   </Popover>
  // );
};

export default Tooltip;
